var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_685_7111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5547 16.9482C33.5953 15.4176 32.0865 14.3046 30.3349 13.8353C28.5832 13.3659 26.7201 13.5754 25.1239 14.4212L23.669 15.2184L22.7837 13.7795C21.824 12.2531 20.3175 11.1433 18.5691 10.6749C16.8207 10.2064 14.9611 10.4142 13.3668 11.2563C10.0913 13.0018 9.52133 16.8939 10.9752 20.1265C13.3964 24.5353 16.0474 28.8166 18.9171 32.9527C18.9171 32.9527 29.0912 28.0729 32.1769 25.8222C35.2626 23.5714 36.4909 20.0903 34.5547 16.9482Z",
    fill: "#F8A1A3",
    stroke: "black",
    strokeWidth: 3.06692,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_685_7111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.2859,
    height: 34.2859,
    fill: "white",
    transform: "translate(9.76508 0.921875) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.d449b09bb2da4d093e642afa2b7b8df1.svg";
export { ForwardRef as ReactComponent };